import { graphql } from "@/lib/gql/__generated__";

export const GoogleFreeBookingLinksSettingsHotelTypeSelectionModal = graphql(`
	query GoogleFreeBookingLinksSettingsHotelTypeSelectionModal($hotelID: ID!) {
		googleFreeBookingLinksSettings(hotelID: $hotelID) {
			id
			hotelID
			status
			notConnectedReason
			hotelType
			hotelName
			address {
				country
				addr1
				addr2
				addr3
				city
				province
				postalCode
			}
			geoLocation {
				lat
				lon
			}
			webSite
			chillnnGuestPageType
			phoneNumbers {
				phoneType
				phoneNumber
			}
			defaultPlanID
			defaultRoomID
			capacity
			createdAt
			updatedAt
		}
	}
`);
